const CreditSection = ({ creditBalance, creditLoading, creditHistory }) => (
        <div>
          {/* Balance card */}
          <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: 24, marginBottom: 24, textAlign: "center" }}>
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", letterSpacing: "0.12em", marginBottom: 8 }}>STORE CREDIT BALANCE</p>
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "36px", fontWeight: 700, color: creditBalance > 0 ? "var(--green)" : "var(--text-dim)", margin: 0 }}>
              ${creditBalance.toFixed(2)}
            </p>
          </div>

          {/* Transaction history */}
          <h3 style={{ fontSize: "18px", marginBottom: 14 }}>Transaction History</h3>
          {creditLoading ? (
            <p style={{ fontFamily: "var(--font-mono)", fontSize: "12px", color: "var(--text-muted)", letterSpacing: "0.1em" }}>LOADING…</p>
          ) : creditHistory.length === 0 ? (
            <p style={{ color: "var(--text-dim)", fontSize: "14px" }}>No store credit transactions yet.</p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {creditHistory.map(tx => (
                <div key={tx.id} style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                      <span style={{
                        fontFamily: "var(--font-mono)", fontSize: "10px", padding: "2px 8px", borderRadius: "var(--radius)", fontWeight: 700,
                        background: tx.type === "issued" ? "var(--green)" : tx.type === "used" ? "var(--amber)" : "var(--red)",
                        color: "#111",
                      }}>{tx.type.toUpperCase()}</span>
                      <span style={{ fontFamily: "var(--font-mono)", fontSize: "12px", color: "var(--text-muted)" }}>
                        {new Date(tx.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                      </span>
                    </div>
                    <p style={{ fontSize: "13px", color: "var(--text-dim)", margin: 0 }}>{tx.reason || "—"}</p>
                    {tx.order_id && <p style={{ fontSize: "11px", color: "var(--text-muted)", fontFamily: "var(--font-mono)", margin: "2px 0 0" }}>{tx.order_id}</p>}
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <p style={{ fontFamily: "var(--font-mono)", fontSize: "16px", fontWeight: 700, color: tx.amount > 0 ? "var(--green)" : "var(--red)", margin: 0 }}>
                      {tx.amount > 0 ? "+" : ""}${Number(tx.amount).toFixed(2)}
                    </p>
                    <p style={{ fontFamily: "var(--font-mono)", fontSize: "11px", color: "var(--text-muted)", margin: 0 }}>
                      Balance: ${Number(tx.balance).toFixed(2)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
);

export default CreditSection;
